// extracted by mini-css-extract-plugin
export var avatarContainer = "_ii-0";
export var avatarTypingWave = "_ii-i";
export var gray = "_ii-f";
export var green = "_ii-c";
export var icon = "_ii-9";
export var image = "_ii-1";
export var lg = "_ii-6";
export var md = "_ii-5";
export var presenceDot = "_ii-b";
export var red = "_ii-d";
export var sm = "_ii-4";
export var status = "_ii-a";
export var typingDot = "_ii-h";
export var typingPill = "_ii-g";
export var xl = "_ii-7";
export var xs = "_ii-3";
export var xxl = "_ii-8";
export var xxs = "_ii-2";
export var yellow = "_ii-e";